import { TeamRole } from './types'
export const isDisabled = (isCoach: boolean, isPlayer: boolean, teamRole: TeamRole) => {
    const { isForCoach, isForPlayer } = teamRole
    if (isPlayer) return !isForPlayer
    if (isCoach) return !isForCoach
    return false
}
